import type {
  ListingActivity,
  PromotedListingSort,
  PromotedListingsParams,
  RiskLevel,
} from '@/client/types/promotion';

/**
 * Filtering, sorting and paging all happen server-side — this is just the UI
 * state and its translation into query params.
 */
export interface ListingFilters {
  query: string;
  risk: RiskLevel[];
  /** 'all' or a concrete `type_name`. */
  type: string;
  activity: 'all' | ListingActivity;
  sort: PromotedListingSort;
}

export const DEFAULT_FILTERS: ListingFilters = {
  query: '',
  risk: [],
  type: 'all',
  activity: 'all',
  sort: 'risk',
};

export const isFiltered = (f: ListingFilters) =>
  f.query !== '' || f.risk.length > 0 || f.type !== 'all' || f.activity !== 'all';

export function toListingParams(
  f: ListingFilters,
  page: number,
  pageSize: number,
): PromotedListingsParams {
  return {
    page,
    page_size: pageSize,
    q: f.query || undefined,
    type: f.type === 'all' ? undefined : f.type,
    risk: f.risk.length ? f.risk : undefined,
    activity: f.activity === 'all' ? undefined : f.activity,
    sort: f.sort,
  };
}
